import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, null, {
    renderEmpty: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.noDataPlaceholder), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_select, {
        value: _ctx.value,
        style: _normalizeStyle({ width: _ctx.width }),
        "allow-clear": "",
        "show-search": "",
        class: _normalizeClass(_ctx.class),
        mode: _ctx.modeType,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        "option-filter-prop": "title",
        onChange: _ctx.onChange,
        onClear: _ctx.onClear,
        maxTagTextLength: _ctx.maxTagTextLength,
        maxTagCount: _ctx.maxTagCount
      }, {
        maxTagPlaceholder: _withCtx((omittedValues) => [
          _createElementVNode("span", {
            style: {"color":"red"},
            title: _ctx.titleValue
          }, "+ " + _toDisplayString(omittedValues.length) + " ...", 9, _hoisted_2)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: item.id,
              value: item.id,
              title: item.name,
              disabled: item.disabled
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["value", "title", "disabled"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "style", "class", "mode", "placeholder", "disabled", "onChange", "onClear", "maxTagTextLength", "maxTagCount"])
    ]),
    _: 1
  }))
}